// Попап регистрации

import basePopup from "./base-popup";
import ajaxForm from "../../components/ajax-form";
import Analytics from "../../marketing/analytics";
import captcha from "../../captcha";
import labeledInput from "../../components/labeled-input";
import inputCheckbox from "../../components/base-checkbox-btn";

const template = /* html */`
    <transition name="fade">
        <base-popup
            id="signup-popup"
            show-logo
            v-cloak
            :isActive="isActive"
            v-show="isActive"
        >
            <template #header>
                <div class="popup__header-text">
                    Зарегистрируйтесь или 
                    <a href="#authorization_popup" class="js-show-popup">войдите</a>
                </div>
            </template>
            <ajax-form
                id="registration-form"
                action="/profile/signup/"
                submit-text="Зарегистрироваться"
                submit-class="popup__button"
                autocomplete="off"
                :reach-goal-on-success="{goalName: 'LOGGED_IN'}"
                :shouldClearErrors="!isActive"
                @captchaFail="reinitCaptcha"
                :invisible-captcha="!isCaptchaVisible"
            >
                <template #default="props">
                    <input type="hidden" name="csrfmiddlewaretoken" :value="csrfToken">
                    <input
                        class="js_next_field"
                        type="hidden"
                        name="next"
                        :value="nextPage"
                    >
                    <labeled-input
                        label="Имя"
                        input-name="full_name"
                        :error="props.errors.full_name?.[0]"
                        helptext="чтобы обращаться к вам в письмах"
                        suggest="name"
                        small
                    />
                    <labeled-input
                        label="Почта"
                        input-name="email"
                        input-type="email"
                        :error="props.errors.email?.[0]"
                        :value="email"
                        helptext="для личного кабинета и важных сообщений"
                        :is-focused="isActive"
                        @input="$emit('emailChanged', $event.target.value)"
                        input-id="id_email"
                        small
                        suggest="email"
                        required
                    />
                    <labeled-input
                        label="Пароль"
                        input-name="password"
                        input-type="password"
                        :error="props.errors.password?.[0]"
                        input-id="id_password"
                        with-help
                        small
                        required
                    />
                    <div class="pt-0_5">
                        <input-checkbox
                            :model-value="true"
                            name="is_subscribed"
                            id="id_is_subscribed"
                        >
                            Раз в месяц получать рассылку с&nbsp;обновлениями «Дадаты»,
                            чтобы не&nbsp;пропускать полезные функции
                        </input-checkbox>
                    </div>
                </template>
                <template #captcha v-if="captchaKey">
                    <div
                        id="signup-popup-captcha"
                        class="js-captcha"
                        :style="{minHeight: isCaptchaVisible ? '105px' : '0'}"
                        :data-sitekey="captchaKey"
                    >
                    </div>
                </template>
                <template #after-submit>
                    <div
                        class="align-center align-left-sm
                        max-w-11 max-w-sm-12 mx-auto mx-sm-0"
                    >
                        Регистрируясь, вы принимаете
                        <a
                            href="/terms"
                            target="_blank"
                        >
                            публичную оферту
                        </a>
                    </div>
                </template>
            </ajax-form>
        </base-popup>
    </transition>
`;

export default {
    template,
    props: {
        nextPage: {
            type: String,
            required: true,
        },
        csrfToken: {
            type: String,
            required: true,
        },
        captchaKey: { type: String },
        email: { type: String },
        isActive: { type: Boolean },
        signupSource: { type: String },
    },
    data() {
        return {
            captchaId: null,
            isCaptchaVisible: false,
        };
    },
    methods: {
        reinitCaptcha() {
            this.captchaId = captcha.reinit(this.captchaId, "#signup-popup-captcha");
            this.isCaptchaVisible = true;
        },
    },
    watch: {
        isActive(newVal) {
            if (!newVal) return;
            window.sessionStorage.setItem("signup_referrer", document.referrer);
            this.isCaptchaVisible = false;
            Analytics.saveSignupPoint();
            Analytics.reachGoal(`SIGNUP_INTERESTED_${this.signupSource}`);
            this.captchaId = captcha.init("#signup-popup-captcha", true);
            setTimeout(() => captcha.execute(this.captchaId), 1000);
        },
    },
    emits: ["emailChanged"],
    components: {
        basePopup,
        ajaxForm,
        labeledInput,
        inputCheckbox,
    },
    name: "SignupPopup",
};
